module.exports = __webpack_public_path__ + "assets/img/newsIcon2.2d062912.png";